<template>
  <div v-if="display">
    <modal-layout-top :title="'Insatsrader'" />
    <div class="content slider-modal">

      <h4>Taxa</h4>
      <table class="table is-fullwidth is-narrow">
        <thead>
          <tr>
            <th>Typ</th>
            <th>Est. tid</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="line in deliveryTemplateItem.lines.filter(x => x.productType === 'Rate')" :key="line.deliveryTemplateItemLineId">
            <td>
              <select class="input is-small" v-model="line.productId">
                <option :value="null">Välj typ...</option>
                <option v-for="product in products.filter(x => x.productType === 'Rate')" :value="product.productId" :key="product.productId">{{ product.productName }}</option>
              </select>
            </td>
            <td><input type="number" class="input is-small" v-model="line.hoursEstimated"></td>
            <td><div class="remove-item" @click="removeDeliveryTemplateItemLine(line)">-</div></td>
          </tr>
        </tbody>
      </table>

      <div class="add-new-item" @click="addRateLine()">+</div>

      <hr class="separator">

      <h4>Hyra</h4>

      <table class="table is-fullwidth is-narrow">
        <thead>
          <tr>
            <th>Typ</th>
            <th>Antal</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="line in deliveryTemplateItem.lines.filter(x => x.productType === 'Rent')" :key="line.deliveryTemplateItemLineId">
            <td>
              <select class="input is-small" v-model="line.productId">
                <option :value="null">Välj typ...</option>
                <option v-for="product in products.filter(x => x.productType === 'Rent')" :value="product.productId" :key="product.productId">{{ product.productName }}</option>
              </select>
            </td>
            <td><input type="number" class="input is-small" v-model="line.quantity"></td>
            <td><div class="remove-item" @click="removeDeliveryTemplateItemLine(line)">-</div></td>
          </tr>
        </tbody>
      </table>

      <div class="add-new-item" @click="addRentLine()">+</div>

      <hr class="separator">

      <div class="is-clearfix" />
      <modal-layout-buttons />
    </div>
  </div>
</template>

<script>
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  props: {
    deliveryTemplateItem: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  data () {
    return {
      display: false
    }
  },
  methods: {
    save () {
      this.$emit('closePanel')
    },
    cancel () {
      this.deliveryTemplateItem.lines = []
      this.$emit('closePanel')
    },
    addRateLine () {
      // Check if there already are empty lines
      const rateLines = this.deliveryTemplateItem.lines.filter(x => x.productType === 'Rate')

      if (rateLines && rateLines.length > 0) {
        if (rateLines.find(x => x.productId === null)) {
          this.$toast('Du har redan en tom rad', 'info')
          return
        }
      }

      this.deliveryTemplateItem.lines.push({
        productId: null,
        productType: 'Rate'
      })
    },
    addRentLine () {
      // Check if there already are empty lines
      const rentLines = this.deliveryTemplateItem.lines.filter(x => x.productType === 'Rent')

      if (rentLines && rentLines.length > 0) {
        if (rentLines.find(x => x.productId === null)) {
          this.$toast('Du har redan en tom rad', 'info')
          return
        }
      }

      this.deliveryTemplateItem.lines.push({
        productId: null,
        productType: 'Rent'
      })
    },

    removeDeliveryTemplateItemLine (deliveryTemplateItemLine) {
      this.deliveryTemplateItem.lines = this.deliveryTemplateItem.lines.filter(x => x !== deliveryTemplateItemLine)
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    if (!this.deliveryTemplateItem.lines) {
      this.deliveryTemplateItem.lines = []
    }

    this.display = true
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/DeliveryTemplateItemModal.vue